module.exports = __webpack_public_path__ + "static/media/uk.837ed83f.svg";